import { render, staticRenderFns } from "./platformSelfOperatedProductModel.vue?vue&type=template&id=22720f10"
import script from "./platformSelfOperatedProductModel.vue?vue&type=script&lang=js"
export * from "./platformSelfOperatedProductModel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports